import { GetRowsRequest } from '../../grid/types/common';
import { FilterKeyMapper, GridRequestToConsolePayload } from '.';

export class ConsoleRequest {
  static createRequest<TResponse>({
    dataProviderType,
    dataProviderEntity = DataProviderEntity.MODEL,
    payload = {},
    endpoint,
    method,
  }: CreateRequestPayload): Promise<TResponse> {
    return new Promise((resolve, reject) => {
      app.getDataProvider(dataProviderType)[dataProviderEntity][endpoint][method](payload, {
        success: resp => resolve(resp),
        failure: (response, err) => reject({ response, err }),
      });
    });
  }

  static mapGridRequestToPayload(
    gridRequest: GetRowsRequest<any, any>,
    timezone: string,
    filterKeyMapper?: FilterKeyMapper
  ) {
    const payload = new GridRequestToConsolePayload(gridRequest, timezone, filterKeyMapper);

    return payload.getPayload();
  }

  static buildDataProviderUrl(dataProviderType: DataProviderType, endpoint: string, raw?: any): string | null {
    return app.buildDataProviderUrl(dataProviderType, endpoint, raw);
  }

  static createRequestUpload<TResponse>({dataProviderType, payload = {}, endpoint, method}): Promise<TResponse>  {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      for (const key in payload) {
        if (payload.hasOwnProperty(key)) {
          formData.append(key, payload[key]);
        }
      }

      fetch(app.getDataProviderUpload(dataProviderType, endpoint, method), {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(response => {
          if (!response.success) {
            reject('Failed to load file');
          }
          resolve(response);
        }).catch(error => {
        reject(error);
      });
    });
  }

}

export interface CreateRequestPayload {
  dataProviderType: DataProviderType;
  dataProviderEntity?: DataProviderEntity;
  payload?: any;
  endpoint: string;
  method: string;
}

export enum DataProviderEntity {
  MODEL = 'model',
  SYSTEM = 'system',
}

export enum DataProviderType {
  CORE = 0x0000,
  EPS = 0x0001,
  SVE = 0x0002,
  MDM = 0x0004,
  REPORTS_BUILDER = 0x0005,
  ENDPOINTS = 0x0003,
  DB_TEST = 0x0200,
  INTEGRATION = 0x0008,
}
